import { createBrowserRouter, RouteObject } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const routes: RouteObject[] = [MainRoutes, LoginRoutes];

const router = createBrowserRouter(routes, {
  basename: import.meta.env.VITE_APP_BASE_NAME as string
});

export default router;
